interface GuestCounterProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  error?: string;
}

export default function GuestCounter({
  value,
  onChange,
  min = 1,
  max = 10,
  error,
}: GuestCounterProps) {
  const increment = () => {
    if (value < max) {
      onChange(value + 1);
    }
  };

  const decrement = () => {
    if (value > min) {
      onChange(value - 1);
    }
  };

  return (
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Number of Guests
      </label>
      <div className="flex items-center space-x-4">
        <button
          type="button"
          onClick={decrement}
          disabled={value <= min}
          className="w-12 h-12 rounded-full bg-lavender text-white font-bold text-xl hover:bg-lavender-dark disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors"
          aria-label="Decrease guest count"
        >
          -
        </button>
        <div className="flex-1 text-center">
          <span className="text-3xl font-bold text-gray-800">{value}</span>
          <p className="text-sm text-gray-600">
            {value === 1 ? 'guest' : 'guests'}
          </p>
        </div>
        <button
          type="button"
          onClick={increment}
          disabled={value >= max}
          className="w-12 h-12 rounded-full bg-lavender text-white font-bold text-xl hover:bg-lavender-dark disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors"
          aria-label="Increase guest count"
        >
          +
        </button>
      </div>
      {error && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
    </div>
  );
}
